import React from 'react';

/**
 * A reusable component to display a user's initial in a circle.
 * @param {string} name - The user's name to get the initial from.
 * @param {string} className - Tailwind classes to override the defaults (e.g., "w-9 h-9 text-sm").
 */
const ProfileIcon = ({ name, className = "" }) => {
  
  // This is the "get user initial" logic you wanted to extract
  const initial = name ? name.charAt(0).toUpperCase() : '?';

  // These are the core styles (color, shape, etc.)
  const baseClasses = "rounded-full bg-blue-600 text-white flex items-center justify-center flex-shrink-0 font-bold shadow-md";

  // These are the *default* styles from your ConversationListItem
  const defaultClasses = "w-12 h-12 text-lg mr-3";

  return (
    <div className={`${baseClasses} ${className || defaultClasses}`}>
      {initial}
    </div>
  );
};

export default ProfileIcon;